module.exports = __webpack_public_path__ + "images/resource-60x60-mind.b69b54c534220ef1c726.png";